import { Badge } from '@/components/ui/badge';

const clamp = (n) => {
  const v = Number(n);
  if (Number.isNaN(v)) return 0;
  return Math.max(0, Math.min(100, v));
};

export const FyreScoreBadge = ({ score }) => {
  const v = clamp(score);
  const tone = v > 80 ? 'good' : v >= 50 ? 'warn' : 'bad';

  const cls =
    tone === 'good'
      ? 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20'
      : tone === 'warn'
        ? 'bg-amber-500/10 text-amber-400 border-amber-500/20'
        : 'bg-rose-500/10 text-rose-400 border-rose-500/20';

  return (
    <Badge className={`${cls} text-xs`}>
      {v}
    </Badge>
  );
};

